import { dateParser } from "../../utils/parser";
import { IAssetModel, IAssetTypeModel } from "./../models/assets";

export const assetAdapter = (data: any): IAssetModel => {
  if (!data) throw new Error("No data provided to assetAdapter");

  const { id, _id, uuid, name, createdAt, type, user, checkDate } = data;
  const assetId = id || _id;

  if (!assetId || !uuid || !name || !createdAt || !type) throw new Error("Invalid data provided to assetAdapter");

  const adaptedAsset: IAssetModel = {
    id: assetId,
    uuid: uuid.slice(-6),
    name,
    type: type.name,
    createdAt: dateParser(createdAt),
    checkDate: checkDate ? dateParser(checkDate) : undefined,
    user: user ? `${user.name} ${user.lastname}` : "-",
  };

  return adaptedAsset;
};

export const assetTypeAdapter = (data: any): IAssetTypeModel => {
  if (!data) throw new Error("No data provided to assetTypesAdapter");

  const { id, _id, name, description } = data;
  const typeId = id || _id;

  if (!typeId || !name) throw new Error("Invalid data provided to assetTypesAdapter");

  const adaptedAssetType = {
    id: typeId,
    name,
    description: description || "-",
  };

  return adaptedAssetType;
};
